











































import { Component, Mixins, Watch } from 'vue-property-decorator'
import BaseVue from '@/mixins/BaseVue'
import customerModule from '@/store/modules/CustomerModule'
import { Customer } from '@/services/connecteur'
import salesOrgsModule from '@/store/modules/SalesOrgsModule'
import CustomerDisplay from '@/components/Customer/CustomerDisplay.vue'
import MassUploadMLADialog from '@/components/Dialogs/ImportMLADialog.vue'
import userModule from '@/store/modules/UserModule'

@Component({
  components: {
    CustomerDisplay,
    MassUploadMLADialog
  }
})
export default class CustomerList extends Mixins(BaseVue) {
  public customerList: Customer[] = []
  public selectedCustomer: Customer = new Customer({ id: 0 })
  public loading = false
  public searchText = ''
  public selectedSalesOrgId = -1
  public dialog = false
  public showMLAUpload = false
  public headers: any[] = [
    { text: this.$t('customer.code'), align: 'left', value: 'code' },
    { text: this.$t('customer.name'), align: 'left', value: 'name' },
    { text: this.$t('customer.mla'), align: 'left', value: 'mla' },
    { text: this.$t('customer.forcedDocType'), align: 'left', value: 'forcedDocType' },
    { text: this.$t('customer.actions'), align: 'center', value: 'actions' }
  ]

  public get salesOrgList() {
    return salesOrgsModule.salesOrgsWithoutDisabled
  }

  @Watch('salesOrgsModule.salesOrgs')
  public async salesOrgsModuleLoaded () {
    const queryId = +this.$route.query.salesOrgId
    if (isNaN(queryId)) {
      this.selectedSalesOrgId = salesOrgsModule.salesOrgsWithoutDisabled[0].id as number
    } else {
      this.selectedSalesOrgId = queryId
    }

    this.fetchData()
  }

  public async fetchData () {
    try {
      this.loading = true
      this.customerList = await customerModule.getCustomers(
        this.selectedSalesOrgId
      )

      const queryId = +this.$route.query.id
      if (!isNaN(queryId)) {
        const customer = this.customerList.find(o => o.id === queryId)
        if (customer) {
          this.showDialog(customer)
        }
      }
    } catch (error) {
      this.displayError(error)
    }
    this.loading = false
  }

  public showDialog (customer: Customer) {
    this.dialog = true
    this.selectedCustomer = new Customer(customer)
  }

  public modalClosed () {
    this.dialog = false
  }

  public closeFileImportDialog (cancelled: boolean) {
    this.showMLAUpload = false
    if (!cancelled) {
      this.fetchData()
    }
  }

  public get perPageOptions () {
    return JSON.parse(`${process.env.VUE_APP_PER_PAGE_OPTIONS}`)
  }

  public get canEditCustomer () {
    const result = userModule.isKeyUserOnSalesOrg(
      this.selectedSalesOrgId
    )
    return result
  }

  public get canUseMassUpload (): boolean {
    return userModule?.canManageCustomer && this.selectedSalesOrgId !== -1
  }
}
